import { Component, OnInit } from '@angular/core';
import { StepService } from '../../stepper/step.service';

@Component({
  selector: 'app-traveler-info',
  templateUrl: './traveler-info.component.html',
  styleUrls: ['./traveler-info.component.scss']
})
export class TravelerInfoComponent implements OnInit {
  showBack;

  constructor(private stepService: StepService) { }

  ngOnInit(): void {
    //hide back if redirected from filled info
    this.stepService.toggle$.subscribe(
      toggle => this.showBack = !toggle
    )
  }

  addChild() {
    this.stepService.prevStep();
  }

  prev() {
    this.stepService.changeStep(6);
  }

  onSubmit() {
    this.stepService.nextStep();
  }

  get user(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  del(index: number) {
    const data = JSON.parse(localStorage.getItem('policy') as string);

    const newData = {
        ...data,
        PassengerInfo: data.PassengerInfo.filter((_: any, i: number) => i !== index)
    };

    localStorage.setItem('policy', JSON.stringify(newData));
}
}
